export default __webpack_public_path__ + "locales/lo-LA/ConnectDialog.json?hash=1f4f20998f4bdab5a36425fc8f2bf5e8";